'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * @copyright 2015, Andrey Popp <8mayday@gmail.com>
                    */

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Time = (_temp = _class = function (_React$Component) {
  _inherits(Time, _React$Component);

  function Time() {
    _classCallCheck(this, Time);

    return _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).apply(this, arguments));
  }

  _createClass(Time, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          locale = _props.locale,
          relative = _props.relative,
          utc = _props.utc,
          format = _props.format,
          valueFormat = _props.valueFormat,
          titleFormat = _props.titleFormat,
          Component = _props.Component,
          props = _objectWithoutProperties(_props, ['value', 'locale', 'relative', 'utc', 'format', 'valueFormat', 'titleFormat', 'Component']);

      if (!value) {
        return _react2.default.createElement(
          'span',
          null,
          'Invalid date'
        );
      }

      if (!_moment2.default.isMoment(value)) {
        value = (0, _moment2.default)(value, valueFormat, true);
      }

      if (locale) {
        value = value.locale(locale);
      }

      if (utc) {
        value = value.utc();
      }

      var machineReadable = value.format('YYYY-MM-DDTHH:mm:ssZ');

      if (relative || format) {
        var humanReadable = relative ? value.fromNow() : value.format(format);
        return _react2.default.createElement(
          Component,
          _extends({
            title: relative ? value.format(titleFormat) : null
          }, props, {
            dateTime: machineReadable }),
          humanReadable
        );
      } else {
        return _react2.default.createElement(
          'time',
          props,
          machineReadable
        );
      }
    }
  }]);

  return Time;
}(_react2.default.Component), _class.propTypes = {

  /**
   * Value.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_moment2.default.fn.constructor), _propTypes2.default.instanceOf(Date), _propTypes2.default.number, _propTypes2.default.string]).isRequired,

  /**
   * If component should output the relative time difference between now and
   * passed value.
   */
  relative: _propTypes2.default.bool,

  /**
   * If set to true will use the utc mode from moment and display all dates
   * in utc disregarding the users locale
   */
  utc: _propTypes2.default.bool,

  /**
   * Datetime format which is used to output date to DOM.
   */
  format: _propTypes2.default.string,

  /**
   * Datetime format which is used to parse value if it's being a string.
   */
  valueFormat: _propTypes2.default.string,

  /**
   * Datetime format which is used to set title attribute on relative or
   * formatted dates.
   */
  titleFormat: _propTypes2.default.string,

  /**
   * Locale.
   */
  locale: _propTypes2.default.string,

  /**
   * Component to use.
   */
  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
}, _class.defaultProps = {
  titleFormat: 'YYYY-MM-DD HH:mm',
  Component: 'time'
}, _temp);
exports.default = Time;



//////////////////
// WEBPACK FOOTER
// ./~/react-time/lib/Time.js
// module id = 1718
// module chunks = 0